export const citiesData = [
  { name: "Ahero" },
  { name: "Athi River" },
  { name: "Baringo" },
  { name: "Bondo" },
  { name: "Bungoma" },
  { name: "Busia" },
  { name: "Butere" },
  { name: "Chepareria" },
  { name: "Chuka" },
  { name: "Eldama Ravine" },
  { name: "Eldoret" },
  { name: "Embu" },
  { name: "Garissa" },
  { name: "Gazi" },
  { name: "Hola" },
  { name: "Homa Bay" },
  { name: "Isiolo" },
  { name: "Iten" },
  { name: "Kabarnet" },
  { name: "Kajiado" },
  { name: "Kakamega" },
  { name: "Kangema" },
  { name: "Kangundo" },
  { name: "Kapenguria" },
  { name: "Kapsabet" },
  { name: "Kapsowar" },
  { name: "Karuri" },
  { name: "Kericho" },
  { name: "Keroka" },
  { name: "Kerugoya" },
  { name: "Kiambu" },
  { name: "Kihancha" },
  { name: "Kijabe" },
  { name: "Kikuyu" },
  { name: "Kilifi" },
  { name: "Kinango" },
  { name: "Kipini" },
  { name: "Kipkelion" },
  { name: "Kisii" },
  { name: "Kisumu" },
  { name: "Kitale" },
  { name: "Kitui" },
  { name: "Konza" },
  { name: "Kwale" },
  { name: "Lamu" },
  { name: "Limuru" },
  { name: "Litein" },
  { name: "Lodwar" },
  { name: "Londiani" },
  { name: "Luanda" },
  { name: "Lugulu" },
  { name: "Machakos" },
  { name: "Magadi" },
  { name: "Makueni Boma" },
  { name: "Malaba" },
  { name: "Malikisi" },
  { name: "Malindi" },
  { name: "Mandera" },
  { name: "Maragua" },
  { name: "Maralal" },
  { name: "Mariakani" },
  { name: "Marsabit" },
  { name: "Maua" },
  { name: "Meru" },
  { name: "Migori" },
  { name: "Molo" },
  { name: "Mombasa" },
  { name: "Moyale" },
  { name: "Mtito Andei" },
  { name: "Muhoroni" },
  { name: "Mumias" },
  { name: "Murang’a" },
  { name: "Mwingi" },
  { name: "Nairobi" },
  { name: "Naivasha" },
  { name: "Nakuru" },
  { name: "Nambare" },
  { name: "Nandi Hills" },
  { name: "Nanyuki" },
  { name: "Naro Moru" },
  { name: "Narok" },
  { name: "Ngong" },
  { name: "Nyahururu" },
  { name: "Nyamira" },
  { name: "Nyeri" },
  { name: "Ogembo" },
  { name: "Ol Kalou" },
  { name: "Othaya" },
  { name: "Oyugis" },
  { name: "Port Victoria" },
  { name: "Pumwani" },
  { name: "Rachuonyo District" },
  { name: "Rongai" },
  { name: "Rumuruti" },
  { name: "Sagana" },
  { name: "Sawa Sawa" },
  { name: "Shimoni" },
  { name: "Siaya" },
  { name: "Sotik" },
  { name: "Sotik Post" },
  { name: "Takaungu" },
  { name: "Taveta" },
  { name: "Thika" },
  { name: "Voi" },
  { name: "Wajir" },
  { name: "Webuye" },
  { name: "Witu" },
  { name: "Wote" },
  { name: "Wundanyi" },
  { name: "Yala" }
];
